/* import __COLOCATED_TEMPLATE__ from './lsg-map-container.hbs'; */
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';

/**
 * This is a generic container that renders a full width map background with an arbitrary component in the center
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['LSG-c-map-container'],

  /**
   * Register services
   */
  googlePlacesService: service('google-places'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * The location that we will use to center the map background container.
   *
   * @param {Location}
   */
  location: null,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /**
   * @inheritDoc
   */
  didInsertElement() {
    this.googlePlacesService.load().then(() => {
      if (this.isDestroying || !this.location) {
        return;
      }

      this.googlePlacesService.renderMap(
        this.get('_mapElementId'),
        this.get('location.lat'),
        this.get('location.lng'),
        {
          draggable: false,
          disableDoubleClickZoom: true,
          draggableCursor: 'default',
          draggingCursor: 'default',
          fullscreenControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          zoom: 8,
          zoomControl: false,
          backgroundColor: '#f0f0f0',
        });
    });
  },

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * Unique id for the map element on the page to target.
   *
   * @type {String}
   */
  _mapElementId: computed(function() {
    return 'LSG-c-map-container--' + this.get('elementId');
  }),

});
